import { render, staticRenderFns } from "./FileManagerTableItemFile.vue?vue&type=template&id=6f8c9f24&scoped=true&"
import script from "./FileManagerTableItemFile.vue?vue&type=script&lang=ts&"
export * from "./FileManagerTableItemFile.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerTableItemFile.vue?vue&type=style&index=0&id=6f8c9f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c9f24",
  null
  
)

export default component.exports